// src/utils/brokerageSettings.js
// Read/write for the single brokerage-wide settings doc edited from Settings > Super
// Admin: the annual cap. Mirrors teamDefaults.js. Who the owner is lives in owner.js;
// the two helpers are re-exported here so existing imports keep working. New code
// imports from owner.js.

import { doc, getDoc, serverTimestamp } from "firebase/firestore";
import { firestored } from "../firebase/firebaseConfig";
import { setDoc } from "./lookOnlyFirestore";
import { assertCanWrite } from "./lookOnly";

export { OWNER_EMAILS, isSuperAdminOwner } from "./owner";

const DOC_PATH = ["settings", "brokerage"];

export const BROKERAGE_SETTINGS_FALLBACK = {
  annualCap: 70000,
};

export async function loadBrokerageSettings() {
  try {
    const ref = doc(firestored, ...DOC_PATH);
    const snap = await getDoc(ref);
    if (!snap.exists()) return { ...BROKERAGE_SETTINGS_FALLBACK };
    const data = snap.data() || {};
    // Only the cap is read back. The document may still carry an old
    // allowedUserIds list from the guest-list days; nothing reads it any more.
    return {
      ...BROKERAGE_SETTINGS_FALLBACK,
      annualCap:
        typeof data.annualCap === "number" && data.annualCap > 0
          ? data.annualCap
          : BROKERAGE_SETTINGS_FALLBACK.annualCap,
    };
  } catch (err) {
    console.error("loadBrokerageSettings failed:", err);
    return { ...BROKERAGE_SETTINGS_FALLBACK };
  }
}

export async function saveBrokerageSettings(values, userId) {
  assertCanWrite();
  const ref = doc(firestored, ...DOC_PATH);
  await setDoc(
    ref,
    {
      ...values,
      updatedAt: serverTimestamp(),
      updatedBy: userId || "",
    },
    { merge: true },
  );
}
